import "./Navbar.css"
import Logo from "../../images/logo.png"
import Phone from "../../images/call.png"
import { Link } from "react-router-dom"
import { useState } from "react"
import C from "../../images/close.png"
import M from "../../images/mm.png"

const Navbar = () => {
  const [navOpen,setNavOpen] = useState(false)
  const isMobile = window.matchMedia("(max-width:450px)").matches

  return (
    <div className="navbar">
      <div className="navLeft">
        <img src={Logo} alt="" className="logo" />
        <Link to="/"><h1 className="logoName">Homeland Irrigation</h1></Link>
      </div>
      <div className="navCenter">
        <ul className="navitems">
          <a href="#home" className="links"><li className="navitem">Home</li></a>
          <a href="#about" className="links"><li className="navitem">About Us</li></a>
          <a href="#services" className="links"><li className="navitem">Services</li></a>
          <a href="#projects" className="links"> <li className="navitem">Projects</li></a>
          <a href="#contact" className="links"><li className="navitem">Contact</li></a>
        </ul>
      </div>
      <div className="navRight">
      {isMobile && <img src={M} alt=""  className="navRightImg" onClick={()=>setNavOpen(!navOpen)}/>}
        <a href="tel:0710535097"><img src={Phone} alt="" className="navRightImg" /></a>
      </div>
      {navOpen && <div className="navOpen">
      <a href="#home">Home</a>
      <a href="#about">About</a>
      <a href="#services">Services</a>
      <a href="#projects">Projects</a>
      <a href="#contact">Contact</a>
      <img src={C} alt="" className='closeImg' onClick={()=>setNavOpen(!navOpen)}/>
    </div>}
    </div>
  )
}

export default Navbar